import { LogoSquare } from 'internalLibrary';
import classes from 'classnames';
import styles from './NavbarPlain.module.scss';

const NavbarPlain = () => (
  <div className={classes(styles.container)}>
    <LogoSquare />
  </div>
);

export default NavbarPlain;
